import React, { ComponentProps } from 'react';

import { BringgPopover } from '@bringg/react-components';
import { getTextFromSerializedEditorState } from '@bringg-frontend/rich-text-editor';

import RichTextEditor from 'bringg-web/components/rich-text-editor/rich-text-editor';
import { workflowAlertsProvider } from 'bringg-web/features/automation-workflows/data-providers/workflow-alerts-provider';

type Props = {
	alertType: number;
};

const getPopupContainer = () => document.getElementById('exceptions-portal');

const AdditionalTextCell = ({ alertType }: Props) => {
	const richText = workflowAlertsProvider.getDescriptionTextByAlertType(alertType);

	if (!richText) {
		return null;
	}

	const initialEditorConfig: ComponentProps<typeof RichTextEditor>['initialEditorConfig'] = {
		namespace: 'alert-additional-text',
		editorState: richText,
		editable: false
	};

	return (
		<BringgPopover
			noArrow
			destroyOnHide
			getPopupContainer={getPopupContainer}
			trigger={['hover']}
			content={<RichTextEditor initialEditorConfig={initialEditorConfig} />}
		>
			<span className="alert-additional-text-anchor">{getTextFromSerializedEditorState(richText)}</span>
		</BringgPopover>
	);
};

export default AdditionalTextCell;
